import { stevieCam } from '../engine/stevieCam-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { l } from '../lib/imports'
import { createId } from '../main/common'
import { tilesDataShip } from './tilesDataShip-sidecar'
import { ITileShip } from './tilesShip'
import { tilesShip } from './tilesShip-sidecar'

export interface ITileMapShip extends IEntity {
  tiles: ITileShip[]
  width: number
  height: number
  ox: number
  oy: number
  tileSize: number
}

const objs: ITileMapShip[] = []
export function getAll() {
  return objs
}

export function killAll() {
  objs.forEach((c) => {
    kill(c)
  })
}
export function kill(obj: ITileMapShip) {
  obj.isDead = true
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    l.forEach(c.tiles, (d) => {
      if (d.imageFloor) {
        d.imageFloor.destroy()
      }
      if (d.imageObject) {
        d.imageObject.destroy()
      }
      if (d.imageShadow) {
        d.imageShadow.destroy()
      }
      if (d.imageStructure) {
        d.imageStructure.destroy()
      }
    })
  })
}
function update(obj: ITileMapShip) {}

export function createTileMapShip(): ITileMapShip {
  let id = createId()

  let obj: ITileMapShip = {
    id,
    eType: 'tile-map-ship',
    isDead: false,
    tiles: [],
    width: 64,
    height: 64,
    ox: 0,
    oy: 0,
    tileSize: 8 * 4,
  }
  objs.push(obj)
  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      let t = tilesShip.create(
        i,
        j,
        i * obj.tileSize + obj.ox,
        j * obj.tileSize + obj.oy,
      )
      obj.tiles.push(t)
      // tiles.setFloor(t, dataListFloor[0])
    }
  }

  forEachTile(obj, (t) => {
    tilesShip.setStructure(t, tilesDataShip.getByName('ship-grid'))
    tilesShip.setFloor(t, null)
  })

  return obj
}

export function forEachTile(obj: ITileMapShip, cb: (t: ITileShip) => void) {
  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      let t = getTileUnsafe(obj, i, j)
      cb(t)
    }
  }

  return obj
}

export function getTile(tileMap: ITileMapShip, tx: number, ty: number) {
  if (!inRange(tileMap, tx, ty)) {
    return null
  }
  return tileMap.tiles[ty * tileMap.width + tx]
}

export function getTileAtMouse(tileMap: ITileMapShip, mx: number, my: number) {
  let cam = stevieCam.get()
  let x = mx / stevieCam.getZoom() - tileMap.ox + cam.camera.scrollX
  let y = my / stevieCam.getZoom() - tileMap.oy + cam.camera.scrollY

  let tx = Math.floor(x / tileMap.tileSize + 0.5)
  let ty = Math.floor(y / tileMap.tileSize + 0.5)

  return getTile(tileMap, tx, ty)
}

export function getTileUnsafe(tileMap: ITileMapShip, tx: number, ty: number) {
  if (!inRange(tileMap, tx, ty)) {
    throw new Error(`out of range! ${tx} {$ty}`)
  }
  return tileMap.tiles[ty * tileMap.width + tx]
}

export function inRange(tileMap: ITileMapShip, tx: number, ty: number) {
  if (tx >= 0 && tx < tileMap.width) {
    if (ty >= 0 && ty < tileMap.height) {
      return true
    }
  }
  return false
}
